import { Injectable } from '@angular/core';
import { ChartConfiguration, ChartData } from 'chart.js';
import { EflowService } from './eflow.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class GraphService {
  constructor(private eflowService: EflowService) {}

  async getGraphFromType(
    type: string,
    params?: any,
  ): Promise<ChartConfiguration> {
    switch (type) {
      case 'YoYMonthlySales':
        return await this.getYoYMonthlySalesConfig(params);
      case 'EdificeYoYMonthlySales':
        return await this.getEdificeYoYMonthlySalesConfig(params);
      default:
        throw new Error(`Unknown graph type: ${type}`);
    }
  }

  getStandardBar(): ChartConfiguration {
    return {
      type: 'bar',
      options: {
        responsive: true,
        devicePixelRatio: 2,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return index % 2 === 1 ? value : '';
                },
              },
            },
          ],
        },
      },
    };
  }

  async getYoYMonthlySalesConfig(params): Promise<ChartConfiguration> {
    const config = this.getStandardBar();
    if (!params.start_date) {
      params.start_date = moment()
        .subtract(3, 'year')
        .startOf('year')
        .format('YYYY-MM-DD');
    }
    if (!params.end_date) {
      params.end_date = moment()
        .subtract(1, 'month')
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    const data = await this.eflowService
      .getYoYMonthlySales(
        params.account_num,
        params.start_date,
        params.end_date,
      )
      .toPromise();
    const datasets = [];
    const colors = ['#2a7de1', '#e7024c', '#f4b400', '#7fb800', '#f4b400'];
    const keys = Object.keys(data);
    for (const i in keys) {
      datasets.push({
        label: keys[i],
        data: data[keys[i]],
        backgroundColor: colors[i],
        borderColor: colors[i],
        borderWidth: 1,
      });
    }
    return {
      ...config,
      data: {
        labels: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        datasets: datasets,
      },
    };
  }

  async getEdificeYoYMonthlySalesConfig(params): Promise<ChartConfiguration> {
    const config = this.getStandardBar();
    if (!params.start_date) {
      params.start_date = moment()
        .subtract(3, 'year')
        .startOf('year')
        .format('YYYY-MM-DD');
    }
    if (!params.end_date) {
      params.end_date = moment()
        .subtract(1, 'month')
        .endOf('month')
        .format('YYYY-MM-DD');
    }
    const data = await this.eflowService
      .getEdificeYoYMonthlySales(
        params.account_num,
        params.start_date,
        params.end_date,
      )
      .toPromise();
    const datasets = [];
    const colors = ['#2a7de1', '#e7024c', '#f4b400', '#7fb800', '#f4b400'];
    const keys = Object.keys(data);
    for (const i in keys) {
      datasets.push({
        label: keys[i],
        data: data[keys[i]],
        backgroundColor: colors[i],
        borderColor: colors[i],
        borderWidth: 1,
      });
    }
    return {
      ...config,
      data: {
        labels: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        datasets: datasets,
      },
    };
  }
}
